/**
 * The theme's public scripts.
 *
 * Import here the JS modules you want to include in the main JS file of the
 * theme (assets/dist/js/public.min.js).
 */

import dropdown from './alpine/dropdown';
import resize from './helpers/resize';
import scroll from './helpers/scroll';
import modal from './components/modal';
import tabs from './components/tabs';
import sliderRows from './components/slider-row';
import lottiePlayer from './components/lottie-player';
import header from './template-parts/header';
import socialShare from './template-parts/single/parts/socialShare';
import productFeatureAnimation from './blocks/product-feature-animation';
import planboxB from './blocks/planbox-b';
import signupForm from './blocks/signup-form';
import closeAccount from './blocks/close-account';
import contactForm from './blocks/contact-form';
import sectionFeaturedIn from './blocks/sections/featured-in';
import skipLink from './template-parts/header/parts/skip-link';
import tableOfContents from './template-parts/single/parts/table-of-contents';
import newsletterForm from './components/newsletter-form';
import comments from './template-parts/single/parts/comments';

document.addEventListener('alpine:init', () => {
  Alpine.data('dropdown', dropdown);
});

document.addEventListener('DOMContentLoaded', () => {
  resize.init();
  scroll.init();
  modal.init();
  tabs.init();
  sliderRows.init();
  lottiePlayer.init();
  header.init();
  socialShare.init();
  productFeatureAnimation.init();
  planboxB.init();
  signupForm.init();
  closeAccount.init();
  contactForm.init();
  sectionFeaturedIn.init();
  skipLink.init();
  tableOfContents.init();
  newsletterForm.init();
  comments.init();
});

/*
 * Actions that require the site to be fully loaded, including assets.
 */
window.addEventListener('load', () => {
  scroll.onResize();
  planboxB.onLoad();
});

/*
 * Throttles resize event so it fires only after user has stopped resizing the window.
 */
window.addEventListener('qustodio:throttledResize', () => {
  scroll.onResize();
  tabs.onResize();
  sliderRows.onResize();
  header.onResize();
  productFeatureAnimation.restart();
  planboxB.onResize();
  sectionFeaturedIn.onResize();
  tableOfContents.onResize();
});

/*
 * Throttles scroll event so it fires only once every x miliseconds.
 */
window.addEventListener('qustodio:throttledScroll', () => {
  planboxB.onScroll();
  tableOfContents.onScroll();
});

/*
 * Actions to run when Qustodio's custom modal is opened.
 */
window.addEventListener('qustodio:modalOpen', (e) => {
  planboxB.onModalOpen(e);
});

/*
 * Actions to run when Qustodio's custom modal is closed.
 */
window.addEventListener('qustodio:modalClosed', (e) => {
  planboxB.onModalClose(e);
});
